
// // src/pages/Roles/RoleList.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import RoleForm from "./RoleForm";
// import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";

// export default function RoleList() {
//   const [roles, setRoles] = useState([]);
//   const [showForm, setShowForm] = useState(false);
//   const [editingRole, setEditingRole] = useState(null);
//   const [openMenuId, setOpenMenuId] = useState(null);

//   const loadRoles = async () => {
//     try {
//       const res = await api.get("/roles");
//       setRoles(res.data.roles || []);
//     } catch (err) {
//       alert("Failed to load roles");
//     }
//   };

//   useEffect(() => {
//     loadRoles();
//   }, []);

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this role? This action cannot be undone.")) return;
//     try {
//       await api.delete(`/roles/${id}`);
//       loadRoles();
//       setOpenMenuId(null);
//     } catch (err) {
//       alert(err?.response?.data?.message || "Cannot delete role (may be in use)");
//     }
//   };

//   return (
//     <div className="p-8 bg-gray-50 min-h-screen">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-10">
//           <h1 className="text-3xl font-bold text-gray-900">All Role</h1>
//           <button
//             onClick={() => {
//               setEditingRole(null);
//               setShowForm(true);
//             }}
//             className="px-8 py-3 bg-[#0f172a] hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg transition"
//           >
//             + New
//           </button>
//         </div>
 
//         {/* Table - Tighter & Cleaner */}
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gray-100 border-b-2 border-gray-300">
//                 <tr>
//                   <th className="px-6 py-4 text-left text-sm font-bold text-gray-700">Name</th>
//                   <th className="px-6 py-4 text-left text-sm font-bold text-gray-700">Caption</th>
//                   <th className="px-6 py-4 text-left text-sm font-bold text-gray-700">Admin Access</th>
//                   <th className="px-6 py-4 text-center text-sm font-bold text-gray-700">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200">
//                 {roles.map((role) => (
//                   <tr key={role.id} className="hover:bg-orange-50/30 transition-colors">
//                     <td className="px-6 py-4 text-gray-900 font-medium text-sm">
//                       {role.name}
//                     </td>
//                     <td className="px-6 py-4 text-gray-700 text-sm">
//                       {role.caption || "-"}
//                     </td>
//                     <td className="px-6 py-4 text-sm">
//                       <span
//                         className={`inline-flex px-3 py-1.5 rounded-full text-xs font-medium ${
//                           role.admin_panel_access
//                             ? "bg-green-100 text-green-800"
//                             : "bg-gray-100 text-gray-600"
//                         }`}
//                       >
//                         {role.admin_panel_access ? "Yes" : "No"}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 text-center relative">
//                       <button
//                         onClick={() => setOpenMenuId(openMenuId === role.id ? null : role.id)}
//                         className="p-2 hover:bg-gray-100 rounded-lg transition"
//                       >
//                         <EllipsisVerticalIcon className="w-5 h-5 text-gray-500" />
//                       </button>

//                       {openMenuId === role.id && (
//                         <div className="absolute right-6 top-12 bg-white border border-gray-200 rounded-xl shadow-2xl py-2 z-50 min-w-36">
//                           <button
//                             onClick={() => {
//                               setEditingRole(role);
//                               setShowForm(true);
//                               setOpenMenuId(null);
//                             }}
//                             className="w-full text-left px-5 py-2.5 text-gray-700 hover:bg-orange-50 transition text-sm"
//                           >
//                             Edit
//                           </button>
//                           <button
//                             onClick={() => handleDelete(role.id)}
//                             className="w-full text-left px-5 py-2.5 text-red-600 hover:bg-red-50 transition text-sm"
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}

//                 {roles.length === 0 && (
//                   <tr>
//                     <td colSpan="4" className="text-center py-12 text-gray-500">
//                       No roles found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Role Form (Sliding or Inline) */}
//         {showForm && (
//           <div className="mt-12">
//             <RoleForm
//               role={editingRole}
//               onDone={() => {
//                 setShowForm(false);
//                 setEditingRole(null);
//                 loadRoles();
//               }}
//               onCancel={() => {
//                 setShowForm(false);
//                 setEditingRole(null);
//               }}
              
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// // src/pages/Roles/RoleList.jsx
// import React, { useEffect, useState } from "react";
// import api from "../../utils/api";
// import RoleForm from "./RoleForm";
// import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
// import { useOutletContext } from 'react-router-dom';
// export default function RoleList() {
//     const { mode } = useOutletContext();
//   const isDark = mode === "dark";

//   const [roles, setRoles] = useState([]);
//   const [showForm, setShowForm] = useState(false);
//   const [editingRole, setEditingRole] = useState(null);
//   const [openMenuId, setOpenMenuId] = useState(null);

//   const loadRoles = async () => {
//     try {
//       const res = await api.get("/roles");
//       setRoles(res.data.roles || []);
//     } catch (err) {
//       alert("Failed to load roles");
//     }
//   };

//   useEffect(() => {
//     loadRoles();
//   }, []);

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this role? This action cannot be undone.")) return;
//     try {
//       await api.delete(`/roles/${id}`);
//       loadRoles();
//       setOpenMenuId(null);
//     } catch (err) {
//       alert(err?.response?.data?.message || "Cannot delete role (may be in use)");
//     }
//   };

//   return (
//     <div className={`p-8 min-h-screen ${isDark ? "bg-slate-900" : "bg-gray-50"}`}>
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-10">
//           <h1 className={`text-3xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>All Roles</h1>
//           <button
//             onClick={() => {
//               setEditingRole(null);
//               setShowForm(true);
//             }}
//             className={`px-8 py-3 font-bold rounded-xl shadow-lg transition ${
//               isDark ? "bg-slate-800 hover:bg-orange-600 text-white" : "bg-[#0f172a] hover:bg-orange-600 text-white"
//             }`}
//           >
//             + New
//           </button>
//         </div>

//         {/* Table */}
//         <div
//           className={`rounded-2xl shadow-xl overflow-hidden border ${
//             isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"
//           }`}
//         >
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className={`${isDark ? "bg-slate-700" : "bg-gray-100"} border-b-2 ${isDark ? "border-slate-600" : "border-gray-300"}`}>
//                 <tr>
//                   <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Name</th>
//                   <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Caption</th>
//                   <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Admin Access</th>
//                   <th className={`px-6 py-4 text-center text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody className={`divide-y ${isDark ? "divide-slate-700" : "divide-gray-200"}`}>
//                 {roles.map((role) => (
//                   <tr key={role.id} className={`hover:${isDark ? "bg-slate-700/50" : "bg-orange-50/30"} transition-colors`}>
//                     <td className={`px-6 py-4 font-medium text-sm ${isDark ? "text-white" : "text-gray-900"}`}>
//                       {role.name}
//                     </td>
//                     <td className={`px-6 py-4 text-sm ${isDark ? "text-slate-300" : "text-gray-700"}`}>
//                       {role.caption || "-"}
//                     </td>
//                     <td className="px-6 py-4 text-sm">
//                       <span
//                         className={`inline-flex px-3 py-1.5 rounded-full text-xs font-medium ${
//                           role.admin_panel_access
//                             ? isDark
//                               ? "bg-green-900/40 text-green-300"
//                               : "bg-green-100 text-green-800"
//                             : isDark
//                             ? "bg-slate-700 text-slate-300"
//                             : "bg-gray-100 text-gray-600"
//                         }`}
//                       >
//                         {role.admin_panel_access ? "Yes" : "No"}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 text-center relative">
//                       <button
//                         onClick={() => setOpenMenuId(openMenuId === role.id ? null : role.id)}
//                         className={`p-2 rounded-lg transition ${
//                           isDark ? "hover:bg-slate-700" : "hover:bg-gray-100"
//                         }`}
//                       >
//                         <EllipsisVerticalIcon className={`w-5 h-5 ${isDark ? "text-slate-400" : "text-gray-500"}`} />
//                       </button>

//                       {openMenuId === role.id && (
//                         <div
//                           className={`absolute right-6 top-12 rounded-xl shadow-2xl py-2 z-50 min-w-36 ${
//                             isDark ? "bg-slate-800 border border-slate-700" : "bg-white border border-gray-200"
//                           }`}
//                         >
//                           <button
//                             onClick={() => {
//                               setEditingRole(role);
//                               setShowForm(true);
//                               setOpenMenuId(null);
//                             }}
//                             className={`w-full text-left px-5 py-2.5 text-sm transition ${
//                               isDark ? "text-slate-200 hover:bg-slate-700" : "text-gray-700 hover:bg-orange-50"
//                             }`}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             onClick={() => handleDelete(role.id)}
//                             className={`w-full text-left px-5 py-2.5 text-sm transition ${
//                               isDark ? "text-red-400 hover:bg-red-950/30" : "text-red-600 hover:bg-red-50"
//                             }`}
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ))}

//                 {roles.length === 0 && (
//                   <tr>
//                     <td colSpan="4" className={`text-center py-12 ${isDark ? "text-slate-400" : "text-gray-500"}`}>
//                       No roles found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Role Form Panel */}
//         {showForm && (
//           <div className="mt-12">
//             <RoleForm
//               role={editingRole}
//               onDone={() => {
//                 setShowForm(false);
//                 setEditingRole(null);
//                 loadRoles();
//               }}
//               onCancel={() => {
//                 setShowForm(false);
//                 setEditingRole(null);
//               }}
//               mode={mode} // ← pass mode for dark/light
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// src/pages/Roles/RoleList.jsx
import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import RoleForm from "./RoleForm";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { useOutletContext } from 'react-router-dom';

// Reusable Action Menu Component
function ActionMenuDropdown({ role, onEdit, onDelete, isDark }) {
  const menuRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={menuRef} className="inline-block relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className={`p-2 rounded-lg transition ${
          isDark ? "hover:bg-slate-700" : "hover:bg-gray-100"
        }`}
      >
        <EllipsisVerticalIcon
          className={`w-5 h-5 ${isDark ? "text-slate-400" : "text-gray-500"}`}
        />
      </button>

      {isOpen && (
        <div
          className={`absolute right-0 top-10 rounded-xl shadow-2xl py-2 z-50 min-w-36 border ${
            isDark
              ? "bg-slate-800 border-slate-700"
              : "bg-white border-gray-200"
          }`}
        >
          <button
            onClick={() => {
              onEdit(role);
              setIsOpen(false);
            }}
            className={`w-full text-left px-5 py-2.5 text-sm transition ${
              isDark
                ? "text-slate-200 hover:bg-slate-700"
                : "text-gray-700 hover:bg-orange-50"
            }`}
          >
            Edit
          </button>

          <button
            onClick={() => {
              onDelete(role.id);
              setIsOpen(false);
            }}
            className={`w-full text-left px-5 py-2.5 text-sm transition ${
              isDark
                ? "text-red-400 hover:bg-red-950/30"
                : "text-red-600 hover:bg-red-50"
            }`}
          >
            Delete
          </button>
        </div>
      )}
    </div>
  );
}

export default function RoleList() {
  const { mode } = useOutletContext();
  const isDark = mode === "dark";

  const [roles, setRoles] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingRole, setEditingRole] = useState(null);

  const loadRoles = async () => {
    try {
      const res = await api.get("/roles");
      setRoles(res.data.roles || []);
    } catch (err) {
      alert("Failed to load roles");
    }
  };

  useEffect(() => {
    loadRoles();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this role? This action cannot be undone.")) return;
    try {
      await api.delete(`/roles/${id}`);
      loadRoles();
    } catch (err) {
      alert(err?.response?.data?.message || "Cannot delete role (may be in use)");
    }
  };

  const handleEdit = (role) => {
    setEditingRole(role);
    setShowForm(true);
  };

  return (
    <div className={`p-8 min-h-screen ${isDark ? "bg-slate-900" : "bg-gray-50"}`}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-10">
          <h1 className={`text-3xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
            All Roles
          </h1>
          <button
            onClick={() => {
              setEditingRole(null);
              setShowForm(true);
            }}
            className={`px-8 py-3 font-bold rounded-xl shadow-lg transition ${
              isDark ? "bg-slate-800 hover:bg-orange-600 text-white" : "bg-[#0f172a] hover:bg-orange-600 text-white"
            }`}
          >
            + New
          </button>
        </div>

        {/* Table */}
        <div
          className={`rounded-2xl shadow-xl overflow-hidden border ${
            isDark ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200"
          }`}
        >
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead
                className={`${isDark ? "bg-slate-700" : "bg-gray-100"} border-b-2 ${
                  isDark ? "border-slate-600" : "border-gray-300"
                }`}
              >
                <tr>
                  <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>
                    Name
                  </th>
                  <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>
                    Caption
                  </th>
                  <th className={`px-6 py-4 text-left text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>
                    Admin Access
                  </th>
                  <th className={`px-6 py-4 text-center text-sm font-bold ${isDark ? "text-slate-300" : "text-gray-700"}`}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className={`divide-y ${isDark ? "divide-slate-700" : "divide-gray-200"}`}>
                {roles.map((role) => (
                  <tr
                    key={role.id}
                    className={`hover:${isDark ? "bg-slate-700/50" : "bg-orange-50/30"} transition-colors`}
                  >
                    <td className={`px-6 py-4 font-medium text-sm ${isDark ? "text-white" : "text-gray-900"}`}>
                      {role.name}
                    </td>
                    <td className={`px-6 py-4 text-sm ${isDark ? "text-slate-300" : "text-gray-700"}`}>
                      {role.caption || "-"}
                    </td>
                    <td className="px-6 py-4 text-sm">
                      <span
                        className={`inline-flex px-3 py-1.5 rounded-full text-xs font-medium ${
                          role.admin_panel_access
                            ? isDark
                              ? "bg-green-900/40 text-green-300"
                              : "bg-green-100 text-green-800"
                            : isDark
                            ? "bg-slate-700 text-slate-300"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      >
                        {role.admin_panel_access ? "Yes" : "No"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <ActionMenuDropdown
                        role={role}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        isDark={isDark}
                      />
                    </td>
                  </tr>
                ))}

                {roles.length === 0 && (
                  <tr>
                    <td colSpan={4} className={`text-center py-12 ${isDark ? "text-slate-400" : "text-gray-500"}`}>
                      No roles found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Role Form Panel */}
        {showForm && (
          <div className="mt-12">
            <RoleForm
              role={editingRole}
              onDone={() => {
                setShowForm(false);
                setEditingRole(null);
                loadRoles();
              }}
              onCancel={() => {
                setShowForm(false);
                setEditingRole(null);
              }}
              mode={mode}
            />
          </div>
        )}
      </div>
    </div>
  );
}